import { Search } from '@/DTOS/PmContract/Search';
import request from '../../utils/request';

const PmContractService = {
  search: (search: Search) => {
    return request('/pmContract/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchComment: (search: Search) => {
    return request('/pmContract/searchComment', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      companyId: any;
      accountSaleId: any;
      projectAuthorId: any;
      enumPmContractStatusId?: number;
      enumPmContractProjectStatusId?: number;
      enumPmOfferContractTypeId: number;
      pmOfferId?: any;
      number: any;
      date: any;
      dateStart?: any;
      dateEnd?: any;
      acquisitionType: any;
      isExpedite: boolean;
      pmContractIntervals: number;
      registrationNumber: any;
      remarks: any;
      costPerKilometer: any;
      pmContractWorkPlaceItems?: any;
      pmContractLaborExtras?: any;
      pmContractComments?: any;
      pmContractWorkPlaceTransportCosts?: any;
      pmContractSectionFiles?: any;
    }
  ) => {
    return request('/pmContract/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          accountSaleId: formData.accountSaleId,
          projectAuthorId: formData.projectAuthorId,
          companyId: formData.companyId,
          enumPmContractStatusId: formData.enumPmContractStatusId,
          enumPmContractProjectStatusId: formData.enumPmContractProjectStatusId,
          enumPmOfferContractTypeId: formData.enumPmOfferContractTypeId,
          pmOfferId: formData.pmOfferId,
          number: formData.number,
          date: formData.date,
          dateStart: formData.dateStart,
          dateEnd: formData.dateEnd,
          acquisitionType: formData.acquisitionType,
          isExpedite: formData.isExpedite,
          pmContractIntervals: formData.pmContractIntervals,
          registrationNumber: formData.registrationNumber,
          remarks: formData.remarks,
          pmContractWorkPlaceItems: formData.pmContractWorkPlaceItems,
          pmContractLaborExtras: formData.pmContractLaborExtras,
          pmContractComments: formData?.pmContractComments,
          pmContractWorkPlaceTransportCosts: formData?.pmContractWorkPlaceTransportCosts,
          pmContractSectionFiles: formData?.pmContractSectionFiles,
          costPerKilometer: formData?.costPerKilometer,
        },
      }),
    });
  },

  upload: (/** @type {any} */ file: any) => {
    return request(
      '/pmContract/uploadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  downloadFile: (/** @type {any} */ id: any) => {
    return request(
      '/pmContract/downloadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: id }),
      },
      true
    );
  },

  downloadCommentFile: (/** @type {any} */ formData: any) => {
    return request(
      '/pmContract/downloadCommentFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: formData,
      },
      true
    );
  },

  downloadAdditionalFile: (/** @type {any} */ id: any) => {
    return request(
      '/pmContract/downloadAdditionalFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: id }),
      },
      true
    );
  },

  print: (search: Search) => {
    return request(
      '/pmContract/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...search } }),
      },
      true
    );
  },

  generatePVRLT: (search: Search) => {
    return request(
      '/pmContract/generatePVRLT',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...search } }),
      },
      true
    );
  },

  additionalAct: (/** @type {any} */ file: any) => {
    return request(
      '/pmContract/additionalAct',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  preview: (
    id: any,
    formData: {
      projectAuthor: any;
      accountSale: any;
      accountSaleId: any;
      projectAuthorId: any;
      companyId: any;
      enumPmContractStatusId?: any;
      enumPmContractProjectStatusId?: any;
      number: any;
      date: any;
      dateStart?: any;
      dateEnd?: any;
      remarks: any;
      company: any;
      enumPmContractStatus?: any;
      enumPmContractProjectStatus?: any;
      pmContractIntervals: any;
      pmContractWorkPlaceItems: any;
      pmContractLaborExtras: any;
    }
  ) => {
    return request(
      '/pmContract/preview',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          request: {
            id: id,
            accountSale: formData.accountSale,
            accountSaleId: formData.accountSaleId,
            projectAuthor: formData.projectAuthor,
            projectAuthorId: formData.projectAuthorId,
            companyId: formData.companyId,
            enumPmContractStatusId: formData.enumPmContractStatusId,
            enumPmContractStatusProjectId: formData.enumPmContractProjectStatusId,
            number: formData.number,
            date: formData.date,
            dateStart: formData.dateStart,
            dateEnd: formData.dateEnd,
            remarks: formData.remarks,
            company: formData.company,
            enumPmContractStatus: formData.enumPmContractStatus,
            enumPmContractStatusProject: formData.enumPmContractProjectStatus,
            pmContractIntervals: formData.pmContractIntervals,
            pmContractWorkPlaceItems: formData.pmContractWorkPlaceItems,
            pmContractLaborExtras: formData.pmContractLaborExtras,
          },
        }),
      },
      true
    );
  },
};

export default PmContractService;
